import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { AccountsandFinanceurl, loanManagementUrl } from "../../../../config";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { suspendedTransactionFields } from "../../../../data/DynamicForm/FormFields/SuspendedTransactionFormField";

const base_url = AccountsandFinanceurl.uri;

const SuspendedSmsTransactionForm = (props) => {
  const initialValues = {
    id: props.data ? props.data.Id : "",
    billRefNumber: props.data ? props.data.Billrefnumber : "",
    businessShortCode: props.data ? props.data.Businessshortcode : "",
    firstName: props.data ? props.data.Firstname : "",
    lastName: props.data ? props.data.Lastname : "",
    invoiceNumber: props.data ? props.data.Invoicenumber : "",
    middleName: props.data ? props.data.Middlename : "",
    msisdn: props.data ? props.data.Msisdn : "",
    orgAccountBalance: props.data ? props.data.Orgaccountbalance : 0,
    thirdPartyTransID: props.data ? props.data.Thirdpartytransid : "",
    transactionType: props.data ? props.data.Transactiontype : "",
    transAmount: props.data ? props.data.Transamount : 0,
    transID: props.data ? props.data.Transname : "",
    transTime: props.data ? props.data.Transtime : "",
    isReconcilled: props.data ? props.data.Isreconcilled : 0,
    companyId: props.data ? props.data.Companyid : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        ...values,
      };

      const mutaionDataEditing = {
        loanId: props.data.Id,
        p_BillRefNumber: values.billRefNumber,
      };

      const response = await executeAnyMutation(
        props.isEditing
          ? "mpesaSmsManualReconciliation"
          : "createSuspendedTransaction",
        props.isEditing ? mutaionDataEditing : mutationData,
        props.isEditing ? "recon" : "suspendedC2B",
        false,
        props.isEditing ? loanManagementUrl.uri : base_url
      );

      if (response.results) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Suspended Transaction ${
            props.isEditing ? "Transaction Reconciled" : "created"
          } successfully.`,
        });
      } else if (response.error) {
        throw new Error(response.error);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={suspendedTransactionFields}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Update and Reconcile (SMS)"
          : "Create Suspended Transaction"
      }
      subtitle={
        props.isEditing
          ? "Update and Reconcile Suspended Transaction"
          : "Create a new Suspended Transaction"
      }
    />
  );
};

export default SuspendedSmsTransactionForm;
